module.exports = __webpack_public_path__ + "static/media/ed26421f-0586-46c1-85cd-550e6f30c87c.675b6ba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/ed26421f-0586-46c1-85cd-550e6f30c87c.jpg
// module id = 862
// module chunks = 0